export const ACCORDION_ITEMS = [
  {
    myth: "Mito: el corazón se renueva por completo cada pocos años.",
    reality:
      "Realidad: la mayoría de tus cardiomiocitos te acompañan toda la vida. Se renuevan muy despacio, menos del 1% al año, y por eso cada latido cuenta: son unos 3.000 millones hasta los 80.",
  },
  {
    myth: "Mito: si te cramplas de noche es que falta potasio.",
    reality:
      "Realidad: la causa más habitual son la fatiga muscular y la falta de estiramiento; el potasio solo explica una parte de los casos. Lo que sí es cierto: dormir bien regula casi todo lo demás.",
  },
  {
    myth: "Mito: el pelo se acostumbra a los cortes y crece más rápido.",
    reality:
      "Realidad: el corte ocurre en la parte muerta del pelo; el folículo, bajo la piel, ni se entera. Crece unos 0,35 mm al día mande quien mande en la peluquería.",
  },
];
